import { Container, ContentContainer } from './styles';

const CenteredBox = ({ children, verticallyCentered }) => (
	<Container verticallyCentered={verticallyCentered}>
		<ContentContainer>{children}</ContentContainer>
	</Container>
);

export default CenteredBox;
